import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  ListSubheader,
  TextField,
  InputAdornment,
} from '@material-ui/core';
import SearchIcon from '@mui/icons-material/Search';
import React, { useState } from 'react';
import { createIdFromLabel, generateRandomId } from '../../../utils/commonUtils';
import { handleValidation } from '../../../utils/formUtils';

const CustomSearchSelect = (props) => {
  const {
    item,
    handleInputChange,
    options,
    labelField,
    valueField,
    hideNullOption,
    nullOptionLabel,
    labelPrefix,
    disabled,
    shouldAppendCode,
    addCodeToEnd,
    className,
    search,
    searchValue,
    searchPlaceholder,
    getSearchInput,
    isSearchable,
  } = props;

  const fieldId = item.fieldName ? createIdFromLabel(item.fieldName) : generateRandomId();

  const [searchInput, setSearchInput] = useState(null);
  const [searchList, setSearchList] = useState(options);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center',
    },
    variant: 'menu',
    autoFocus: isSearchable ? false : true,
  };

  const getErrorMessage = () => {
    const errorMsgs = [];
    item?.validations?.forEach((validation) => {
      if (item.errors[validation]) {
        errorMsgs.push(item.errors[validation]);
      }
    });
    return errorMsgs.length > 0 ? errorMsgs[0] : null;
  };

  const onChange = (e) => {
    const inputValue = e.target.value;
    const currField = { ...item };
    currField.value = inputValue;
    handleValidation(currField);
    handleInputChange(currField);
  };

  const searchTextInput = (searchinput) => {
    return getSearchInput(searchinput);
  };

  return (
    <FormControl
      className={className ?? 'w-100'}
      required={item.validations && item.validations.includes('required')}
      error={getErrorMessage() ? true : false}
    >
      <InputLabel id={fieldId + '_label'}>
        {labelPrefix} {item.fieldName}
      </InputLabel>
      <Select
        disabled={disabled}
        labelId={fieldId + '_label'}
        id={fieldId + '_select'}
        autoWidth={false}
        value={item.value}
        onChange={(e) => {
          onChange(e);
        }}
        MenuProps={MenuProps}
        onClose={() => {
          if (!search) {
            props?.getSearchInput?.('');
          } else {
            setSearchInput('');
            setSearchList(options);
          }
        }}
      >
        {isSearchable && (
          <ListSubheader className='custom-search-text'>
            <TextField
              value={!search ? searchValue : searchInput}
              autoFocus
              fullWidth
              placeholder={searchPlaceholder}
              onChange={(e) => searchTextInput(e.target.value)}
              className='custom-search-input'
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              onClick={(e) => {
                e.stopPropagation();
              }}
              onKeyDown={(e) => {
                if (e.key !== 'Escape') {
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
        )}
        {!hideNullOption && (
          <MenuItem value=''>
            <em>{nullOptionLabel || 'None'}</em>
          </MenuItem>
        )}

        {options?.map((item, key) => {
          return typeof item === 'object' ? (
            <MenuItem key={key} value={item[valueField || 'id']}>
              {item['url'] && (
                <img
                  style={{ width: '20px', height: '20px' }}
                  className='mx-2'
                  src={item['url']}
                  alt={item['name']}
                />
              )}{' '}
              {shouldAppendCode && !addCodeToEnd && item['code'] ? `${item['code']} --- ` : ''}
              {item[labelField || 'name']}
              {shouldAppendCode && addCodeToEnd && item['code'] ? ` --- ${item['code']}  ` : ''}
            </MenuItem>
          ) : (
            <MenuItem key={key} value={item}>
              {item}
            </MenuItem>
          );
        })}
      </Select>
      <FormHelperText>{getErrorMessage()}</FormHelperText>
    </FormControl>
  );
};

export default CustomSearchSelect;
